import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Extinguisher Kit",
        price: 90,
        disprice: 80,
        stock: 10,
        content: "Ensure your safety with our premium fire extinguisher. Meticulously crafted for quick response and effective fire suppression, our fire extinguisher is a crucial addition to your safety equipment.",
        description: "Our fire extinguisher offers rapid response and efficient fire control, ideal for homes, offices, and industrial setups. Built with quality and precision, it ensures you're prepared for any emergency.",
        category: ["Safety Equipment", "Fire Gear"],
        tags: ["extinguisher", "gear", "firstaid"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "SafetyPro" },
            { id: 2, title: "Capacity", content: "5 lbs" },
            { id: 3, title: "Class", content: "ABC" },
            { id: 4, title: "Usage", content: "Home, Office, Industrial" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "John Smith",
                date: "Jan 15, 2024",
                rating: 5,
                content: "I'm impressed with the quality and effectiveness of this fire extinguisher. It's easy to use and provides a sense of security at home."
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Alice Johnson",
                date: "Feb 01, 2024",
                rating: 5,
                content: "The compact design of this fire extinguisher makes it easy to store, and I feel much more secure now. It's compact and easy to store. Great product!"
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Two-Way Radios",
        price: 90,
        disprice: 80,
        stock: 8,
        content: "Ensure your safety with our premium two-way radios. Meticulously crafted for reliable communication and quick response, this device is a crucial addition to your emergency equipment.",
        description: "Our two-way radios are designed for instant and effective communication. Ideal for home, office, or industrial use, they offer dependable connectivity during emergencies and routine operations alike.",
        category: ["Communication Tools", "Emergency Tools"],
        tags: ["radio", "gear", "headset"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "SafetyPro" },
            { id: 2, title: "Capacity", content: "5 lbs" },
            { id: 3, title: "Class", content: "ABC" },
            { id: 4, title: "Usage", content: "Home, Office, Industrial" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "John Smith",
                date: "Jan 15, 2024",
                rating: 5,
                content: "I'm impressed with the quality and effectiveness of this product. It's easy to use and provides a sense of security at home."
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Alice Johnson",
                date: "Feb 01, 2024",
                rating: 5,
                content: "The compact design makes it easy to store, and I feel much more secure now. Great product!"
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Fire Helmets",
        price: 120,
        disprice: 100,
        stock: 5,
        content: "Protect your team with our high-performance fire helmets. Engineered for durability and safety, they provide superior head protection in high-risk environments.",
        description: "Our fire helmets are built to withstand extreme conditions. With a heat-resistant shell, adjustable fit, and enhanced visibility features, they’re ideal for firefighters and emergency responders.",
        category: ["Fire Gear", "Safety Equipment"],
        tags: ["helmet", "gear", "extinguisher"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "RescueShield" },
            { id: 2, title: "Material", content: "Heat-Resistant Composite" },
            { id: 3, title: "Color", content: "Red" },
            { id: 4, title: "Usage", content: "Firefighting, Rescue Operations" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "David Lee",
                date: "Mar 10, 2024",
                rating: 5,
                content: "These helmets are solid and reliable. Comfortable fit and great protection in the field."
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Sara Kim",
                date: "Mar 18, 2024",
                rating: 4,
                content: "Really durable and lightweight. Would recommend for any rescue team."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "First Aid Kits",
        price: 60,
        disprice: 45,
        stock: 0,
        content: "Be prepared for any emergency with our all-in-one first aid kits. Compact, comprehensive, and easy to use—ideal for on-the-go or station use.",
        description: "Our first aid kits include a wide range of essential medical supplies like bandages, antiseptics, gloves, scissors, and more. Designed for quick response in fire stations, vehicles, or outdoor emergencies.",
        category: ["Medical Supplies", "Safety Equipment"],
        tags: ["firstaid", "gear", "alarm"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "SafeGuard" },
            { id: 2, title: "Contents", content: "120+ Medical Items" },
            { id: 3, title: "Size", content: "Portable (10\" x 7\" x 3\")" },
            { id: 4, title: "Usage", content: "Fire Stations, Vehicles, Homes" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Rachel Morris",
                date: "Apr 02, 2024",
                rating: 5,
                content: "Super handy and well-organized. We keep one in every vehicle. Highly recommended."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Tom Harris",
                date: "Apr 08, 2024",
                rating: 4,
                content: "Has everything you need in a compact box. Great quality for the price."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Fire Alarms",
        price: 85,
        disprice: 65,
        stock: 10,
        content: "Stay alert and safe with our high-performance fire alarms. Quick detection, loud alerts, and easy installation for maximum protection.",
        description: "Our fire alarms feature advanced smoke and heat sensors to provide rapid alerts in case of danger. Ideal for homes, offices, and industrial buildings. Designed for reliability and long-lasting performance.",
        category: ["Emergency Tools", "Fire Gear"],
        tags: ["alarm", "gear", "flashlight"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "SecureSense" },
            { id: 2, title: "Type", content: "Smoke & Heat Detector" },
            { id: 3, title: "Power", content: "Battery Operated (9V)" },
            { id: 4, title: "Installation", content: "Wall or Ceiling Mount" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Liam Foster",
                date: "Apr 12, 2024",
                rating: 5,
                content: "Loud and reliable—exactly what we needed for our station. Install was a breeze."
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Emily Zhang",
                date: "Apr 14, 2024",
                rating: 4,
                content: "Solid build and clear alarm. Great peace of mind for our office setup."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Fire Axes",
        price: 55,
        disprice: 42,
        stock: 9,
        content: "Heavy-duty fire axes built for emergency response. Strong grip, sharp blade, and durable steel for tough rescue situations.",
        description: "Our fire axes are crafted with a hardened steel blade and a non-slip fiberglass handle. Designed for maximum impact and reliability in fire and rescue missions. A must-have for every firefighter’s toolkit.",
        category: ["Emergency Tools", "Fire Gear"],
        tags: ["axe", "gear", "helmet"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "ResQTools" },
            { id: 2, title: "Material", content: "Forged Steel & Fiberglass" },
            { id: 3, title: "Length", content: "36 inches" },
            { id: 4, title: "Handle", content: "Shock-Absorbing Grip" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Carlos Rivera",
                date: "Mar 5, 2024",
                rating: 5,
                content: "Great balance and super tough. Helped us during a real extraction—highly recommend!"
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Sophia Blake",
                date: "Mar 9, 2024",
                rating: 4,
                content: "Durable and easy to swing. Perfect addition to our gear locker."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Megaphone",
        price: 45,
        disprice: 36,
        stock: 3,
        content: "Powerful megaphone for crowd control and emergency communication. Loud, clear sound with built-in siren mode.",
        description: "This high-performance megaphone delivers up to 800 yards of clear, amplified sound. Features include a voice recording function, adjustable volume, and a powerful siren for urgent situations. Ideal for emergency responders, schools, and public safety events.",
        category: ["Communication Tools", "Emergency Tools"],
        tags: ["megaphone", "radio", "headset"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "VoxAlert" },
            { id: 2, title: "Range", content: "800 yards" },
            { id: 3, title: "Battery", content: "8 x C Batteries" },
            { id: 4, title: "Features", content: "Siren, Record/Playback, Adjustable Volume" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Elena Moore",
                date: "Feb 17, 2024",
                rating: 5,
                content: "Crystal clear sound and the siren feature is really useful during drills. Worth every penny."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Tyson Grant",
                date: "Feb 20, 2024",
                rating: 4,
                content: "Loud and lightweight. Perfect for our safety team during events."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "LED Flashlight",
        price: 30,
        disprice: 24,
        stock: 0,
        content: "High-performance LED flashlight for emergency situations and outdoor activities. Bright, durable, and energy-efficient.",
        description: "This compact LED flashlight delivers exceptional brightness and long battery life. Built for tough conditions, it’s perfect for camping, hiking, or emergency preparedness. Features a weather-resistant design and adjustable beam.",
        category: ["Emergency Tools", "Safety Equipment"],
        tags: ["flashlight", "gear", "alarm"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "LightPro" },
            { id: 2, title: "Brightness", content: "1000 Lumens" },
            { id: 3, title: "Battery", content: "Rechargeable Li-ion" },
            { id: 4, title: "Material", content: "Aluminum Alloy" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Linda Green",
                date: "March 1, 2024",
                rating: 5,
                content: "This flashlight is amazing! Super bright and durable. It’s a must-have for outdoor adventures."
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Chris Walker",
                date: "March 4, 2024",
                rating: 4,
                content: "Really bright and energy efficient. It’s a bit heavy but works perfectly for night hikes."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Headset",
        price: 100,
        disprice: 80,
        stock: 10,
        content: "Reliable communication headsets for clear, hands-free conversations in high-noise environments.",
        description: "These communication headsets are engineered for seamless connectivity and superior sound quality. Ideal for industrial settings, team operations, and emergency services, offering comfort and durability for long shifts.",
        category: ["Communication Tools", "Safety Equipment"],
        tags: ["headset", "radio", "megaphone"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "CommTech" },
            { id: 2, title: "Connectivity", content: "Wireless Bluetooth" },
            { id: 3, title: "Battery Life", content: "15 Hours" },
            { id: 4, title: "Material", content: "Polycarbonate" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Mark Spencer",
                date: "February 20, 2024",
                rating: 5,
                content: "Fantastic sound quality! Perfect for team communication during events. Comfortable to wear for long hours."
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Sarah Lee",
                date: "February 22, 2024",
                rating: 4,
                content: "Good headset for the price. Sound quality is clear, but it could be a bit more comfortable on the ears."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Extinguisher Kit",
        price: 120,
        disprice: 95,
        stock: 25,
        content: "Complete extinguisher kit with everything you need for fire safety. Easy to use and highly effective.",
        description: "Our Extinguisher Kit includes a high-quality fire extinguisher, safety instructions, and essential tools for handling small fires. Perfect for home, office, and vehicle use, this kit provides reliable fire protection in emergencies.",
        category: ["Safety Equipment", "Fire Gear"],
        tags: ["extinguisher", "gear", "firstaid"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "FireGuard" },
            { id: 2, title: "Size", content: "5 lbs" },
            { id: 3, title: "Type", content: "ABC Powder" },
            { id: 4, title: "Material", content: "Aluminum and Steel" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "David Miller",
                date: "March 10, 2024",
                rating: 5,
                content: "This extinguisher kit has everything I need for peace of mind. Highly recommend for safety-conscious homeowners!"
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Emily Roberts",
                date: "March 12, 2024",
                rating: 4,
                content: "Great kit with all the necessary tools. Easy to use and practical. A little bulky, but overall a good value."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Radio Device",
        price: 70,
        disprice: 55,
        stock: 30,
        content: "Reliable two-way radio device for clear communication in any situation. Durable, compact, and easy to use.",
        description: "The Radio Device offers seamless communication, ideal for outdoor activities, emergencies, or team coordination. Built with durable materials and a long-lasting battery, this device ensures clear communication, even in remote areas.",
        category: ["Communication Tools", "Emergency Tools"],
        tags: ["radio", "headset", "gear"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Range", content: "Up to 5 miles" },
            { id: 2, title: "Battery", content: "Rechargeable, 12 hours usage" },
            { id: 3, title: "Frequency", content: "VHF/UHF" },
            { id: 4, title: "Material", content: "ABS Plastic" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Lucas Turner",
                date: "April 2, 2024",
                rating: 5,
                content: "Amazing range and sound quality. It's perfect for our outdoor trips. I can't imagine going camping without it!"
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Sophia Bennett",
                date: "April 5, 2024",
                rating: 4,
                content: "Great value for the price. Works well, though the battery life could be better for extended trips."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Helmet Gear",
        price: 60,
        disprice: 50,
        stock: 0,
        content: "High-quality helmet gear designed for maximum protection and comfort. Ideal for firefighting and emergency services.",
        description: "Helmet Gear provides essential protection during high-risk activities such as firefighting, construction, and other dangerous environments. Made with durable materials for head protection while ensuring comfort and stability.",
        category: ["Fire Gear", "Safety Equipment"],
        tags: ["helmet", "gear", "flashlight"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-impact ABS Plastic" },
            { id: 2, title: "Weight", content: "1.5 lbs" },
            { id: 3, title: "Size", content: "Universal fit" },
            { id: 4, title: "Certification", content: "NFPA 1971 Certified" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Ethan Ward",
                date: "March 20, 2024",
                rating: 5,
                content: "Extremely comfortable and protective. This helmet provides excellent security while still being lightweight."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Isabella Miller",
                date: "March 25, 2024",
                rating: 4,
                content: "Good quality, but a bit tight around the chin. Overall, it's a solid helmet for safety."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Aid Kit",
        price: 45,
        disprice: 35,
        stock: 50,
        content: "Comprehensive first aid kit designed to provide essential medical supplies in emergency situations.",
        description: "This first aid kit is designed to help treat minor injuries or provide immediate care in case of emergencies. It includes various medical supplies, including bandages, antiseptics, gauze, and more, all packed in a compact, easy-to-carry case.",
        category: ["Medical Supplies", "Safety Equipment"],
        tags: ["firstaid", "gear", "extinguisher"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Contents", content: "Bandages, Antiseptic wipes, Gauze pads, Medical tape, Scissors, Tweezers" },
            { id: 2, title: "Dimensions", content: "9 x 6 x 3 inches" },
            { id: 3, title: "Weight", content: "1.2 lbs" },
            { id: 4, title: "Storage", content: "Compact, waterproof case" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Olivia Brown",
                date: "April 10, 2024",
                rating: 5,
                content: "Perfect for my car. It's well-organized and contains everything I might need in an emergency!"
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Liam Wilson",
                date: "April 15, 2024",
                rating: 4,
                content: "Great kit with lots of useful items. Would be even better if it included a few more medical tools."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Alarm System",
        price: 120,
        disprice: 100,
        stock: 30,
        content: "Advanced alarm system for home or office security, providing real-time alerts and protection.",
        description: "Our alarm system is designed to offer top-notch security for your home or business. Equipped with motion detectors, door/window sensors, and an integrated control panel, it ensures that your property remains safe at all times. Real-time alerts keep you informed of any potential threats.",
        category: ["Emergency Tools", "Safety Equipment"],
        tags: ["alarm", "gear", "radio"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Power Source", content: "Battery-powered" },
            { id: 2, title: "Sensors", content: "Motion detectors, Door/window sensors" },
            { id: 3, title: "Connectivity", content: "Wi-Fi and Bluetooth-enabled" },
            { id: 4, title: "Alarm Volume", content: "95 dB" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Sophia Davis",
                date: "March 25, 2024",
                rating: 5,
                content: "This alarm system gives me peace of mind! Easy to install and works perfectly. Highly recommend!"
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Jackson Lee",
                date: "March 28, 2024",
                rating: 4,
                content: "Great product overall, but I had some issues with syncing it to my smartphone initially."
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Fire Axe",
        price: 60,
        disprice: 50,
        stock: 20,
        content: "Durable fire axe designed for effective rescue operations and fire-fighting tasks.",
        description: "Our Fire Axe is an essential tool for emergency responders. Featuring a high-quality steel blade and an ergonomic handle, it's perfect for breaking through obstacles during rescue or firefighting efforts. With its sturdy construction and balanced design, it ensures reliable performance in critical situations.",
        category: ["Emergency Tools", "Fire Gear"],
        tags: ["axe", "gear", "helmet"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-carbon steel blade" },
            { id: 2, title: "Handle", content: "Fiberglass reinforced" },
            { id: 3, title: "Length", content: "36 inches" },
            { id: 4, title: "Weight", content: "5 lbs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Michael Brown",
                date: "April 3, 2024",
                rating: 5,
                content: "This fire axe is incredibly sturdy and sharp. It performs well in intense situations. A must-have for firefighters."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Emily White",
                date: "April 5, 2024",
                rating: 4,
                content: "Great product overall. The handle could be a little more ergonomic, but the blade is fantastic."
            }
        ]
    }
];

export default products;